import { ArrowUpRight } from "lucide-react";
import { Reveal, Tag } from "./Reveal";
import { CTA } from "./CTA";
import { scrollToTarget } from "../lib/scroll";

const SERVICES = [
  { name: "Kitchen cabinet installation", desc: "Give your kitchen an entirely new look without necessarily doing an entire gut renovation." },
  { name: "Custom bathrooms", desc: "From practical upgrades to complete spa-like transformations." },
  { name: "Backsplashes & tile", desc: "Sometimes a relatively small change completely transforms a room." },
  { name: "Flooring", desc: "Beautiful installation with obsessive attention to transitions, edges and finishing." },
  { name: "Roofing", desc: "Protect the thing underneath everything else: your home." },
  { name: "Repairs & restoration", desc: "Damage, deterioration, age and the unexpected — we'll help make your home whole again." },
  { name: "Custom home improvements", desc: "Have something else in mind? Ask us. If it's part of your home, there's a good chance we can help." },
];

export const Services = () => (
  <section id="services" className="py-24 lg:py-40 bg-ink text-bone" data-testid="services-section">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
        <Reveal className="lg:col-span-7">
          <Tag light>More than kitchens</Tag>
          <h2 className="mt-6 font-display font-semibold tracking-[-0.02em] leading-[0.95] text-[2.4rem] sm:text-6xl lg:text-7xl">
            Whatever your home needs, let's talk about it.
          </h2>
        </Reveal>
        <Reveal className="lg:col-span-4 lg:col-start-9" delay={0.1}>
          <p className="text-base sm:text-lg text-bone/60 leading-relaxed">
            Some projects start because something has to change — water damage, age, a roof at the end of its life. Others start with something much more fun: <span className="text-bone font-medium">I want my house to be beautiful.</span> Both are equally valid reasons to renovate.
          </p>
        </Reveal>
      </div>

      <div className="mt-20 border-t border-bone/15">
        {SERVICES.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.04} y={20}>
            <button
              onClick={() => scrollToTarget("#quote-form")}
              className="group w-full text-left grid grid-cols-12 gap-4 items-center py-6 sm:py-8 border-b border-bone/15 transition-colors duration-300 hover:bg-bone/[0.04]"
              data-testid={`service-item-${i}`}
            >
              <span className="col-span-2 sm:col-span-1 font-mono text-xs text-bone/40">{String(i + 1).padStart(2, "0")}</span>
              <span className="col-span-9 sm:col-span-5 font-display font-medium text-xl sm:text-3xl lg:text-4xl tracking-[-0.015em] transition-transform duration-500 group-hover:translate-x-3 group-hover:text-teal">{s.name}</span>
              <span className="col-span-12 sm:col-span-5 sm:col-start-7 pl-[calc(16.67%+1rem)] sm:pl-0 text-sm sm:text-base text-bone/55 leading-relaxed">{s.desc}</span>
              <ArrowUpRight className="hidden sm:block col-span-1 justify-self-end h-6 w-6 text-bone/40 transition-all duration-300 group-hover:text-teal group-hover:-translate-y-1 group-hover:translate-x-1" />
            </button>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-14">
        <CTA variant="light" onClick={() => scrollToTarget("#quote-form")} testId="services-tell-us-btn" className="min-w-[280px]">
          Tell us about your project
        </CTA>
      </Reveal>
    </div>
  </section>
);
